import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-359d035b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clientRepairVideos" }
const _hoisted_2 = { class: "back" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "videoType" }
const _hoisted_5 = { class: "searchInput" }
const _hoisted_6 = { class: "videoList" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("i", {
        class: "iconfont icon-fanhui",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backHandler && _ctx.backHandler(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_select, {
          ref: el=>_ctx.refMap.set('videoType',el),
          modelValue: _ctx.otherParams.queryParam.videoTypeId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.otherParams.queryParam.videoTypeId) = $event)),
          placeholder: "请选择视频种类",
          clearable: "",
          style: {"width":"100%"},
          onChange: _cache[2] || (_cache[2] = (val)=>{_ctx.selectOnChange(val,'videoType')})
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comboSelect({comboId:'videoType'}), (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.otherParams.queryParam.filterKey,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.otherParams.queryParam.filterKey) = $event)),
          placeholder: "请输入车型名称"
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, null, {
              icon: _withCtx(() => [
                _createElementVNode("i", {
                  class: "iconfont icon-sousuo",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.searchHandler && _ctx.searchHandler(...args)))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_collapse, {
          modelValue: _ctx.otherParams.active,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.otherParams.active) = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherParams.videoData, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_collapse_item, {
                title: item.name,
                name: index
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.desc) + "  ", 1),
                  (item.url)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "play",
                        onClick: ($event: any) => (_ctx.play(item.url,item.id))
                      }, "播放", 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["title", "name"]))
            }), 256))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}